import { environment } from './../../../../environments/environment';
import { Injectable } from "@angular/core";
import { AppHttpClient } from "src/app/core-features/auth-guard/http-client.service";

@Injectable()
export class ProjectService {
  private domain = environment.CORE_LINK;
  //private domain="http://192.168.11.19:8080/concillium-user-management-service-0.0.1/";

  private urls = {
    Project: `${this.domain}/api/v2/projects`,
    // get: `${this.domain}/api/v1/projects`,
    // getAll: `${this.domain}/api/v1/projects`,
    // create: `${this.domain}/api/v1/projects`,
    // update: `${this.domain}/api/v1/projects`,
    // delete: `${this.domain}/api/v1/projects`,
    exists: `${this.domain}/api/accounts/user/exists`,
    details: `${this.domain}/api/accounts/user/details`,
    dummy: "api/usermanger"
  };

  constructor(
    private http: AppHttpClient,
  ) {}
  getAllProject() {
    // 
    return this.http.get( this.urls.Project);
  } 
  getAll(pno, psize,key) {
    return this.http.get( this.urls.Project  + "?pageNo=" + pno + "&pageSize=" + psize + "&search="+key );
  } 

  get(id: number) {
    return this.http.get(`${this.urls.Project}/${id}`);
  }

  create(data) {
    return this.http.post(this.urls.Project, data);
  }

  update(id, data) {
    return this.http.put(`${this.urls.Project}/${id}`, data);
  }

  delete(id: number) {
    return this.http.delete(`${this.urls.Project}/${id}`);
  }

  exists(data) {
    return this.http.post(this.urls.exists, data);
  }

  details() {
    return this.http.get(this.urls.details);
  }
}
